import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import { Section, SmSpace } from 'm2m.components';
import { FuncaoParticipante, NotaComercialApiResponse } from 'common/genericTypes';
import {
  tipoSerieDescriptions,
  negociacaoSecundariaDescriptions,
  depositariaEmissaoDescriptions,
  tipoLiquidacaoDescriptions,
  garantiaTipoDescriptions,
  garantiaSubTipoDescriptions,
  contraparteRecebedoraDescriptions,
} from 'common/genericDescriptions';
import moment from 'moment';
import { addCpfCnpjMask } from 'utils/mask';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

interface Props {
  caracteristicas: NotaComercialApiResponse;
}

export const DetalhesCaracteristicas: React.FC<Props> = (props) => {
  const { caracteristicas } = props;
  const isUsuarioCustodiante = useSelector((state: RootState) => Boolean(state.auth.usuario.participante.funcao === FuncaoParticipante.Custodiante));
  const currentParticipanteCnpj = useSelector((state: RootState) => state.auth.usuario.participante.cnpj);

  return (
    <>
      <Section title={'Características da Emissão'} defaultGrid>
        <div>
          <Typography variant="body2">{'Número da Emissão:'}</Typography>
          <Typography variant="body1">{caracteristicas.numeroEmissao}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Número da série:'}</Typography>
          <Typography variant="body1">{caracteristicas.numeroSerie}</Typography>
          <SmSpace />
        </div>
        {caracteristicas.tipoSerie && (
          <div>
            <Typography variant="body2">{'Tipo de série:'}</Typography>
            <Typography variant="body1">{tipoSerieDescriptions[caracteristicas.tipoSerie]}</Typography>
            <SmSpace />
          </div>
        )}
        <div>
          <Typography variant="body2">{'Possui Vasos Comunicantes:'}</Typography>
          <Typography variant="body1">{caracteristicas.vasosComunicantes ? 'Sim' : 'Não'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Regime Fiduciário:'}</Typography>
          <Typography variant="body1">{caracteristicas.regimeFiduciario ? 'Sim' : 'Não'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Distribuição Pública:'}</Typography>
          <Typography variant="body1">{caracteristicas.distribuicaoPublica ? 'Sim' : 'Não'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Negociação Secundária por:'}</Typography>
          <Typography variant="body1">
            {negociacaoSecundariaDescriptions[caracteristicas.negociacaoSecundariaPor]}
          </Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Cártula Formalizado:'}</Typography>
          <Typography variant="body1">{caracteristicas.cartulaEmissaoFormalizado ? 'Sim' : 'Não'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Depositária Emissão:'}</Typography>
          <Typography variant="body1">{depositariaEmissaoDescriptions[caracteristicas.depositariaEmissao]}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Anúncio de Início de Distribuição:'}</Typography>
          <Typography variant="body1">{caracteristicas.utilizacaoAnuncioInicioDistribuicao ? 'Sim' : 'Não'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'UF da Emissão:'}</Typography>
          <Typography variant="body1">{caracteristicas.ufLocalEmissao}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Município de Emissão:'}</Typography>
          <Typography variant="body1">{caracteristicas.localEmissao}</Typography>
          <SmSpace />
        </div>
        {caracteristicas.classificadoraRisco1 && (
          <div>
            <Typography variant="body2">{'Classificadora de Risco 1:'}</Typography>
            <Typography variant="body1">{caracteristicas.classificadoraRisco1}</Typography>
            <SmSpace />
          </div>
        )}
        {caracteristicas.classificadoraRisco2 && (
          <div>
            <Typography variant="body2">{'Classificadora de Risco 2:'}</Typography>
            <Typography variant="body1">{caracteristicas.classificadoraRisco2}</Typography>
            <SmSpace />
          </div>
        )}
        {caracteristicas.rating1 && (
          <div>
            <Typography variant="body2">{'Rating 1:'}</Typography>
            <Typography variant="body1">{caracteristicas.rating1}</Typography>
            <SmSpace />
          </div>
        )}
        {caracteristicas.rating2 && (
          <div>
            <Typography variant="body2">{'Rating 2:'}</Typography>
            <Typography variant="body1">{caracteristicas.rating2}</Typography>
            <SmSpace />
          </div>
        )}
        <div>
          <Typography variant="body2">{'UF do Pagamento:'}</Typography>
          <Typography variant="body1">{caracteristicas.ufLocalPagamento}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Município do Pagamento:'}</Typography>
          <Typography variant="body1">{caracteristicas.localPagamento}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Nome Resp. Infos. (DRI):'}</Typography>
          <Typography variant="body1">{caracteristicas.nomeResponsavelPelasInformacoesDRI}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'E-mail Resp. Infos. (DRI):'}</Typography>
          <Typography variant="body1">{caracteristicas.emailResponsavelPelasInformacoesDRI}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Tipo de Liquidação:'}</Typography>
          <Typography variant="body1">{tipoLiquidacaoDescriptions[caracteristicas.tipoLiquidacao]}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Banco Liquidante do Emissor:'}</Typography>
          <Typography variant="body1">{caracteristicas.bancoLiquidanteEmissor}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'CNPJ Banco Liquid. Emissor:'}</Typography>
          <Typography variant="body1">{addCpfCnpjMask(caracteristicas.cnpjBancoLiquidanteEmissor)}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Cód. Banco Vinculado à Emissão:'}</Typography>
          <Typography variant="body1">{caracteristicas.codigoBancoContaCorrenteVinculadaEmissao}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Ag. Vinculada à Emissão:'}</Typography>
          <Typography variant="body1">{caracteristicas.numeroAgenciaContaCorrenteVinculadaEmissao}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Nº CC. Vinculada à Emissão:'}</Typography>
          <Typography variant="body1">{caracteristicas.numeroContaCorrenteVinculadaEmissao}</Typography>
          <SmSpace />
        </div>
        {caracteristicas.chaveExterna && (
          <div>
            <Typography variant="body2">{'Chave Externa:'}</Typography>
            <Typography variant="body1">{caracteristicas.chaveExterna}</Typography>
            <SmSpace />
          </div>
        )}
        {caracteristicas.isin && (
          <div>
            <Typography variant="body2">{'Código ISIN:'}</Typography>
            <Typography variant="body1">{caracteristicas.isin}</Typography>
            <SmSpace />
          </div>
        )}
        {caracteristicas.descricaoAdicional && (
          <div>
            <Typography variant="body2">{'Descrição Adicional:'}</Typography>
            <Typography variant="body1">{caracteristicas.descricaoAdicional}</Typography>
            <SmSpace />
          </div>
        )}
        {caracteristicas.codigoExterno && (
          <div>
            <Typography variant="body2">{'Código Externo:'}</Typography>
            <Typography variant="body1">{caracteristicas.codigoExterno}</Typography>
            <SmSpace />
          </div>
        )}
        {caracteristicas.razaoSocialEscriturador && !caracteristicas.distribuicaoPublica && (
          <div>
            <Typography variant="body2">{'Razão Social Escriturador:'}</Typography>
            <Typography variant="body1">{caracteristicas.razaoSocialEscriturador}</Typography>
            <SmSpace />
          </div>
        )}
        {caracteristicas.cnpjEscriturador && !caracteristicas.distribuicaoPublica && (
          <div>
            <Typography variant="body2">{'CNPJ Escriturador:'}</Typography>
            <Typography variant="body1">{addCpfCnpjMask(caracteristicas.cnpjEscriturador)}</Typography>
            <SmSpace />
          </div>
        )}
      </Section>
      {caracteristicas.distribuicaoPublica && (
        <Section title={'Distribuição Pública'}>
          <Grid container spacing={5} style={{ width: '100%' }}>
            <Grid item md={6}>
              {caracteristicas.tipoDistribuicaoPublica && (
                <div>
                  <Typography variant="body2">{'Tipo de Distribuição Pública:'}</Typography>
                  <Typography variant="body1">{caracteristicas.tipoDistribuicaoPublica}</Typography>
                  <SmSpace />
                </div>
              )}
            </Grid>
            <Grid item md={6}>
              {caracteristicas.dataEncerramentoDistribuicao && (
                <div>
                  <Typography variant="body2">{'Data de Encerramento da Distribuição:'}</Typography>
                  <Typography variant="body1">
                    {moment(caracteristicas.dataEncerramentoDistribuicao).format('DD/MM/YYYY')}
                  </Typography>
                  <SmSpace />
                </div>
              )}
            </Grid>
            <Grid item md={6}>
              {caracteristicas.contraparteRecebedora && (
                <div>
                  <Typography variant="body2">{'Contraparte Recebedora:'}</Typography>
                  <Typography variant="body1">{contraparteRecebedoraDescriptions[caracteristicas.contraparteRecebedora]}</Typography>
                  <SmSpace />
                </div>
              )}
            </Grid>
            <Grid item md={12}>
              {caracteristicas?.coordenadores?.length > 0 && (
                <div>
                  <Typography variant="body2">{'Coordenadores:'}</Typography>
                  <Typography variant="body1">
                    {caracteristicas.coordenadores.map((c) => c.razaoSocial).join(', ')}
                  </Typography>
                  <SmSpace />
                </div>
              )}
            </Grid>
            {caracteristicas.coordenadorLider && (
              <>
                <Grid item md={6}>
                  <div>
                    <Typography variant="body2">{'Razão Social Coord. Líder:'}</Typography>
                    <Typography variant="body1">{caracteristicas.coordenadorLider.razaoSocial}</Typography>
                    <SmSpace />
                  </div>
                </Grid>
                <Grid item md={6}>
                  <div>
                    <Typography variant="body2">{'CNPJ Coord. Líder:'}</Typography>
                    <Typography variant="body1">{addCpfCnpjMask(caracteristicas.coordenadorLider.cnpj)}</Typography>
                    <SmSpace />
                  </div>
                </Grid>
              </>
            )}
            <Grid item md={6}>
              {caracteristicas.razaoSocialEscriturador && (
                <div>
                  <Typography variant="body2">{'Razão Social Escriturador:'}</Typography>
                  <Typography variant="body1">{caracteristicas.razaoSocialEscriturador}</Typography>
                  <SmSpace />
                </div>
              )}
            </Grid>
            <Grid item md={6}>
              {caracteristicas.cnpjEscriturador && (
                <div>
                  <Typography variant="body2">{'CNPJ Escriturador:'}</Typography>
                  <Typography variant="body1">{addCpfCnpjMask(caracteristicas.cnpjEscriturador)}</Typography>
                  <SmSpace />
                </div>
              )}
            </Grid>
          </Grid>
        </Section>
      )}
      {caracteristicas.regimeFiduciario && (
        <Section title={'Regime Fiduciário'} defaultGrid>
          {caracteristicas.coobrigacao && (
            <div>
              <Typography variant="body2">{'Coobrigação:'}</Typography>
              <Typography variant="body1">{caracteristicas.coobrigacao ? 'Sim' : 'Não'}</Typography>
              <SmSpace />
            </div>
          )}
          {caracteristicas.naturezaAgenteFiduciario && (
            <div>
              <Typography variant="body2">{'Natureza Agente Fiduciário:'}</Typography>
              <Typography variant="body1">{caracteristicas.naturezaAgenteFiduciario}</Typography>
              <SmSpace />
            </div>
          )}
          {caracteristicas.razaoSocialAgenteFiduciario && (
            <div>
              <Typography variant="body2">{'Razão Social Agente Fiduciário:'}</Typography>
              <Typography variant="body1">{caracteristicas.razaoSocialAgenteFiduciario}</Typography>
              <SmSpace />
            </div>
          )}
          {caracteristicas.cpfCnpjAgenteFiduciario && (
            <div>
              <Typography variant="body2">{'CNPJ Agente Fiduciário:'}</Typography>
              <Typography variant="body1">{addCpfCnpjMask(caracteristicas.cpfCnpjAgenteFiduciario)}</Typography>
              <SmSpace />
            </div>
          )}
        </Section>
      )}
      {!(caracteristicas.custodiantes?.length === 0) && (
        <Section title={'Custodiantes'} defaultGrid>
          {caracteristicas.custodiantes?.filter((custodiante) => {
            if (isUsuarioCustodiante) {
              return custodiante.cnpjInstituicaoCustodiante === currentParticipanteCnpj
            }
            return true
          }).map((custodiante) => {
            let razaoCustodiante = custodiante.razaoSocialInstituicaoCustodiante;
            let cnpjCustodiante = custodiante.cnpjInstituicaoCustodiante;
            return (
              <>
                <div>
                  <Typography variant="body2">{'Razão Social Inst. Custodiante:'}</Typography>
                  <Typography variant="body1">{razaoCustodiante}</Typography>
                  <SmSpace />
                </div>
                <div>
                  <Typography variant="body2">{'CNPJ Inst. Custodiante:'}</Typography>
                  <Typography variant="body1">{addCpfCnpjMask(cnpjCustodiante)}</Typography>
                  <SmSpace />
                </div>

                {custodiante?.informacoesBancarias && custodiante?.informacoesBancarias?.length > 0 &&
                  (
                    custodiante.informacoesBancarias[0].ispbBanco?.length > 0 ||
                    custodiante.informacoesBancarias[0].agenciaBanco?.length > 0 ||
                    custodiante.informacoesBancarias[0].contaBanco?.length > 0 ||
                    custodiante.informacoesBancarias[0].razaoSocialBanco?.length > 0
                  )
                  && (
                    <>
                      <div>
                        <Typography variant="body2">{'ISPB:'}</Typography>
                        <Typography variant="body1">{custodiante.informacoesBancarias[0].ispbBanco}</Typography>
                        <SmSpace />
                      </div>

                      <div>
                        <Typography variant="body2">{'Razão Social Banco:'}</Typography>
                        <Typography variant="body1">{custodiante.informacoesBancarias[0].razaoSocialBanco ?? ''}</Typography>
                        <SmSpace />
                      </div>
                      <div>
                        <Typography variant="body2">{'Agência Bancária:'}</Typography>
                        <Typography variant="body1">{custodiante.informacoesBancarias[0].agenciaBanco ?? ''}</Typography>
                        <SmSpace />
                      </div>
                      <div>
                        <Typography variant="body2">{'Conta Bancária:'}</Typography>
                        <Typography variant="body1">{custodiante.informacoesBancarias[0].contaBanco ?? ''}</Typography>
                        <SmSpace />
                      </div>
                    </>
                  )}
              </>
            )
          })
          }
        </Section>
      )}
      {!(caracteristicas.garantias?.length === 0) && (
        <Section title={'Garantias'} defaultGrid>
          {caracteristicas.garantias?.map((garantia) => {
            let tipo = garantiaTipoDescriptions[garantia.id];
            let subtipos = garantia.subTipos.map((subtipo) => { return (<Typography variant="body1">{garantiaSubTipoDescriptions[subtipo.id]}</Typography>) });
            return (
              <>
                <div>
                  <Typography variant="body2">{'Garantia tipo:'}</Typography>
                  <Typography variant="body1">{tipo}</Typography>
                  <SmSpace />
                </div>
                <div>
                  <Typography variant="body2">{'Garantia Subtipo:'}</Typography>
                  {subtipos}
                  <SmSpace />
                </div>
              </>
            )
          })
          }
          <div>
            <Typography variant="body2">{'Descrição Adicional Garantia:'}</Typography>
            <Typography variant="body1">{caracteristicas.descricaoAdicionalGarantias}</Typography>
            <SmSpace />
          </div>
        </Section>
      )}
    </>
  );
};
